import * as React from 'react';
import TouchSlider from './TouchSlider';
import OTDisplayGL from './OTDisplayGL';

const OTView = ({ overtones, setOTGain, OTGain, Q, HPGain, setHPGain, setOffness }) => {
	return (
		<div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<div style={{ width: '100%', height: '55%', margin: 'auto' }}>
				<OTDisplayGL Q={Q} OTGain={OTGain} overtones={overtones} />
			</div>

			<div style={{ width: '100%',height:"11%",marginTop:0 }}>
				<div key={0} style={{ height: '100%', width: '50%', float: 'left' }}>
					<TouchSlider
						defaultValue={OTGain[0]}
						setValue={v => setOTGain(0, Math.pow(v, 3) / 25)}
						min={0}
						max={5}
						label={'⨯' + overtones[0]}
					/>
				</div>
				<div key={1} style={{ height: '100%', width: '50%', float: 'right' }}>
					<TouchSlider
						defaultValue={OTGain[1]}
						setValue={v => setOTGain(1, Math.pow(v, 3) / 25)}
						min={0}
						max={5}
						label={'⨯' + overtones[1]}
					/>
				</div>
			</div>
			<div style={{ width: '100%',height:"11%",marginTop:0 }}>
				<div key={2} style={{ height: '100%', width: '50%', float: 'left' }}>
					<TouchSlider
						defaultValue={OTGain[2]}
						setValue={v => setOTGain(2, Math.pow(v, 3) / 25)}
						min={0}
						max={5}
						label={'⨯' + overtones[2]}
					/>
				</div>
				<div key={3} style={{ height: '100%', width: '50%', float: 'right' }}>
					<TouchSlider
						defaultValue={OTGain[3]}
						setValue={v => setOTGain(3, Math.pow(v, 3) / 25)}
						min={0}
						max={5}
						label={'⨯' + overtones[3]}
					/>
				</div>
			</div>
			<div style={{ height: '11%',marginTop:0 }}>
				<TouchSlider
					defaultValue={HPGain}
					setValue={v => setHPGain(Math.pow(v, 4) / 0.125)}
					min={0}
					max={0.5}
					label={'⨯' + 9 + '+'}
				/>
			</div>
			<div style={{ height: '11%',marginTop:0 }}>
				<TouchSlider defaultValue={0} setValue={v => setOffness(v)} min={0} max={0.4} label={'unhinge'} />
			</div>
		</div>
	);
};

export default OTView;
